import React from 'react';
import classNames from 'classnames';
import IgniteDropdownSearch from '../../../neuro-ui/lib/DropdownSearch/DropdownSearch';
import { QuestionTypeViewPropTypes } from '../../utils';
import { useNeuroMessages } from '../MessageContext';

const DropdownSearch = (props) => {
  const {
    className,
    valueChanged,
    question,
    value: { value = {} } = {},
  } = props;

  const messageContext = useNeuroMessages();
  const answers = question.answers || [];
  const attributes = question?.attributes || {};
  const currentValue = value && value.length > 0 ? value[0] : value;
  const selectedOption = answers.find((a) => a.key === currentValue);
  const classes = classNames(className, {
    'dropdown-search': true,
  });
  const isSearchable = Object.prototype.hasOwnProperty.call(
    attributes,
    'isSearchable'
  )
    ? attributes.isSearchable
    : true;

  const options = answers.map((option, index) => {
    return {
      label: messageContext.formatIntlMessage({
        id: `${question.appkey}.${option.key}`,
      }),
      value: option.key || index,
    };
  });

  const onChange = (v) => {
    valueChanged(v);
  };

  //TODO: add pleaseSelect to common messages -JJames
  const placeholder =
    messageContext.getMessage(`${question.appkey}.input.placeholder`) ||
    messageContext.getMessage({ id: 'pleaseSelect' });

  return (
    <div className={classes}>
      <div className="dropdown-search__container">
        <IgniteDropdownSearch
          isSearchable={isSearchable}
          onChange={onChange}
          options={options}
          value={selectedOption ? selectedOption.key : null}
          placeholder={placeholder}
          noOptionsPlaceholderFn={(v) => `'${v}' is not listed`}
        />
      </div>
    </div>
  );
};

DropdownSearch.propTypes = QuestionTypeViewPropTypes;

export default DropdownSearch;
